import React, { createContext, useContext, useState, useEffect } from "react";
import { getUserById } from "../services/api/users";
import { logout as apiLogout } from "../services/api/logout";
import { decodeJWT } from "../utils/getUserByToken";

const UserContext = createContext();

export const useUser = () => useContext(UserContext);

// Dicionário para traduzir os níveis
const levelTranslations = {
  admin: "Administrador",
  assistant: "Assistente",
  common: "Corretor", // Adicionamos a nova tradução aqui
};

export const UserProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchUserData = async () => {
      const userId = localStorage.getItem("currentUserId");
      const token = localStorage.getItem("token");

      if (!userId || !token) {
        setIsLoading(false);
        return;
      }

      try {
        const userDataFromApi = await getUserById(userId);
        const decodedToken = decodeJWT();
        
        const englishLevel = decodedToken.position || "";

        const translatedLevel =
          levelTranslations[englishLevel.toLowerCase()] || englishLevel;

        setCurrentUser({
          ...userDataFromApi,
          nome: userDataFromApi.full_name,
          nivel: translatedLevel,
        });
      } catch (error) {
        console.error("Falha ao montar dados do usuário:", error);
        apiLogout();
        setCurrentUser(null);
      } finally {
        setIsLoading(false);
      }
    };

    fetchUserData();
  }, []);

  const logout = () => {
    apiLogout();
    setCurrentUser(null);
  };

  return (
    <UserContext.Provider
      value={{ currentUser, setCurrentUser, logout, isLoading }}
    >
      {children}
    </UserContext.Provider>
  );
};